import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html,
  body {
    color: ${({ theme }) => theme.colors.white};
    padding: 0;
    margin: 0;
    height: 100%;
    font-family: ${({ theme }) => theme.font.family};
    font-size: ${({ theme }) => theme.font.size}px;
    background: ${({ theme }) => theme.colors.background};
  }

  body {
    margin: 0;
    padding: 0;
    width: 100%;
    min-height: 100%;
  }
  body > div:first-child {
    min-height: 100%;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
  * {
    box-sizing: border-box;
  }
`;

export default GlobalStyle;
